export { isValidEmail, parseEmail, sanitizeEmail } from "./email";
export { getPasswordStrength, isValidPassword, type PasswordStrength } from "./password";

/** Trim a string; return null if empty or non-string. */
export function parseTrimmedString(input: unknown): string | null {
  if (typeof input !== "string") return null;
  const t = input.trim();
  return t.length > 0 ? t : null;
}

/** Trim a name string (shorthand for `value.trim()`). */
export function sanitizeName(name: string): string {
  return name.trim();
}
